import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';

const TestCheckboxList = ({ testsByCategory, selectedTestIds, onTestToggle }) => {
    // ✅ Hook luôn đặt ở top-level
    const [openParents, setOpenParents] = useState([]);

    if (!testsByCategory || testsByCategory.length === 0) {
        return <div className="text-muted">No tests available.</div>;
    }

    const toggleParent = (parentId) => {
        setOpenParents((prev) =>
            prev.includes(parentId)
                ? prev.filter((id) => id !== parentId)
                : [...prev, parentId]
        );
    };

    const isOpen = (parentId) => openParents.includes(parentId);

    const getSelectedCount = (category) =>
        category.tests.filter((t) => selectedTestIds.includes(t.id)).length;

    const getTotalCount = (category) => category.tests.length;

    const getParentSelectedCount = (parent) =>
        parent.children.reduce((sum, child) => sum + getSelectedCount(child), 0);

    const getParentTotalCount = (parent) =>
        parent.children.reduce((sum, child) => sum + getTotalCount(child), 0);

    return (
        <div className="d-flex flex-column gap-3">
            {testsByCategory.map((parent) => (
                <Card key={parent.parentCategoryId}>
                    <Card.Header
                        role="button"
                        onClick={() => toggleParent(parent.parentCategoryId)}
                        className="d-flex justify-content-between align-items-center"
                    >
                        <strong>{parent.parentCategoryName}</strong>
                        <span className="text-muted small">
                            ({getParentSelectedCount(parent)} / {getParentTotalCount(parent)} selected)
                            <span className="ms-2">
                                {isOpen(parent.parentCategoryId) ? '▲' : '▼'}
                            </span>
                        </span>
                    </Card.Header>

                    {isOpen(parent.parentCategoryId) && (
                        <Card.Body>
                            {parent.children.map((child) => (
                                <Card key={child.categoryId} className="mb-3">
                                    <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                                        <strong className="ms-2">
                                            ├─ {child.categoryName}
                                        </strong>
                                        <span className="text-muted small">
                                            ({getSelectedCount(child)} / {getTotalCount(child)} selected)
                                        </span>
                                    </Card.Header>

                                    <Card.Body className="d-flex flex-column gap-2">
                                        {child.tests.map((test) => (
                                            <Form.Check
                                                key={test.id}
                                                type="checkbox"
                                                id={`test-${test.id}`}
                                                label={
                                                    <div>
                                                        <strong>{test.name}</strong>
                                                        {test.description && (
                                                            <div className="text-muted small">
                                                                {test.description}
                                                            </div>
                                                        )}
                                                    </div>
                                                }
                                                checked={selectedTestIds.includes(test.id)}
                                                onChange={(e) =>
                                                    onTestToggle(test.id, e.target.checked)
                                                }
                                            />
                                        ))}
                                    </Card.Body>
                                </Card>
                            ))}
                        </Card.Body>
                    )}
                </Card>
            ))}
        </div>
    );
};

export default TestCheckboxList;
